export default {
  methods: {
    zoomButtonPosition() {
      const zoomPosition = this.moduleData.options?.zoom_position || {};
      const xPosition = zoomPosition.x_position;
      const yPosition = zoomPosition.y_position;
      // xPosition and yPosition are percentages between 0 and 1:
      // 0 = start (left or top)
      // 1 = end (right or bottom)
      // 0.5 = center
      if (xPosition === 0 && yPosition === 0) return 'top-left';
      if (xPosition === 1 && yPosition === 0) return 'top-right';
      if (xPosition === 0 && yPosition === 1) return 'bottom-left';
      if (xPosition === 1 && yPosition === 1) return 'bottom-right';
      return 'bottom-right'; // default value
    },
  },
};
